module.exports = __webpack_public_path__ + "static/media/6780.6b9d6f80.jpg";